import * as React from 'react';
const SvgPlusIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={15} fill="none" {...props}>
    <path
      fill="#fff"
      d="M12.805 6.503h-4.46V1.88a1.197 1.197 0 1 0-2.395 0v4.622H1.192a1.197 1.197 0 0 0 .005 2.395h4.758v4.594a1.197 1.197 0 1 0 2.396 0V8.898h4.46c.661 0 1.197-.536 1.197-1.198a1.207 1.207 0 0 0-1.203-1.197Z"
    />
  </svg>
);
export default SvgPlusIcon;
